import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";

export const CommonControllerApi = createApi({
  reducerPath: "commonControllerApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    updateReviewRequiredApi: builder.mutation({
      query: ({ questionId, data }: any) => ({
        url: `/${questionId}`,
        method: "PUT",
        body: data
      }),
      extraOptions: { service: "Question_Fetch" }
    }),
    updateQuestionVersionApi: builder.mutation({
      query: ({ questionId, data }: any) => ({
        url: `/question/${questionId}/version-details`,
        method: "PUT",
        body: data
      }),
      extraOptions: { service: "Question_Fetch" }
    })
  })
});

export const {
  useUpdateReviewRequiredApiMutation,
  useUpdateQuestionVersionApiMutation
} = CommonControllerApi;
